import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tab-title"
export default class extends Controller {
  static targets = ["title"]

  connect() {
    const tabs = this.element.querySelectorAll('[data-toggle="tab"]');

    tabs.forEach(tab => {
      tab.addEventListener('click', (event) => {
        const newTitle = tab.dataset.title;
        if (this.hasTitleTarget) {
          this.titleTarget.textContent = newTitle;
        }
      });
    });
  }
}
